import { Component, OnInit, ElementRef, HostBinding } from '@angular/core';
import { IColumnComponent } from 'src/app/types/@types/sl-v-types';
import { Column } from 'angular-slickgrid';
import { ISLMap } from 'src/app/types/@types/sl-map';
import { SLLayer } from 'src/app/model/sl-layer';

@Component({
	selector: 'app-actions-column',
	templateUrl: './actions-column.component.html',
	styleUrls: ['./actions-column.component.scss']
})
export class ActionsColumnComponent implements OnInit, IColumnComponent {

	private gid: string;
	private map: ISLMap;
	private layer: SLLayer;
	public isReady = false;
	@HostBinding('class.stateful') true;
	@HostBinding('class.isReady') get() { return this.isReady; }

	constructor(private domNode: ElementRef) { }


	ngOnInit() {
		this.isReady = true;
	}

	SetData(
		cellNode: HTMLElement,
		row: number,
		dataContext: any,
		colDef: Column,
		map: ISLMap,
		layer: SLLayer
	): void {
		this.gid = dataContext.gid;
		this.map = map;
		this.layer = layer;
	}

	ZoomToFeature(gid): void {
		this.map.component.HandleToolAction({
			action: 'info/zoom-to-features',
			layer: this.layer.id,
			features: [this.gid]
		});
	}
	EditFeature() {
		this.map.component.HandleToolAction({
			action: 'info/edit-feature',
			layer: this.layer,
			feature: this.gid,
      forceRefresh:true
		});
	}
	EditFeatureGeometry() {
		this.map.component.HandleToolAction({
			action: 'info/edit-feature-geometry',
			layer: this.layer.id,
			feature: this.gid
		});
	}

}
